import { GitPullRequest } from "lucide-react";

const STACKS = [
  "VB6 / VB.NET",
  "Microsoft Access",
  "Classic ASP / ColdFusion",
  "Legacy .NET Framework",
  "Excel-heavy workflows",
  "Old desktop utilities",
  "FoxPro / dBase",
  "Hand-tended scripts",
];

export function Modernize() {
  return (
    <section className="section modernize" id="modernize">
      <div className="container">
        <div className="modernize-inner">
          <div className="reveal">
            <span className="eyebrow">Legacy modernization</span>
            <h2
              className="t-h2"
              style={{ margin: "12px 0 16px", fontSize: "clamp(32px,3.4vw,44px)" }}
            >
              Your old VB6 app can keep running
              <br />
              while the <em>new one rolls in.</em>
            </h2>
            <p className="t-lead" style={{ margin: 0, fontSize: 17 }}>
              Many businesses still depend on Access databases, Excel-heavy
              workflows, ColdFusion sites, or old .NET Framework apps.
              Modernization doesn't have to mean "throw it all away." We
              stabilize what's working, replace what's risky, and keep the lights
              on the whole way.
            </p>
            <ul className="modernize-list">
              {STACKS.map((s) => (
                <li key={s}>{s}</li>
              ))}
            </ul>
          </div>

          <div className="modernize-art reveal" aria-hidden>
            <span className="code-tag">
              <GitPullRequest size={12} /> staged migration · v0.4
            </span>
            <CodeLine ln="14" text="Connection conn = new Connection();" />
            <CodeLine ln="15" text={`conn.Open "DSN=LegacyDb;UID=sa;PWD=…"`} kind="del" />
            <CodeLine ln="15" text="await using var db = new AppDb(cfg);" kind="add" />
            <CodeLine ln="16" text="// pulls from same source-of-truth" />
            <CodeLine ln="17" text={`Set rs = conn.Execute("SELECT * …")`} kind="del" />
            <CodeLine ln="17" text="var rows = await db.Invoices" kind="add" />
            <CodeLine ln="18" text="    .Where(i => i.Open).ToListAsync();" kind="add" />
            <CodeLine ln="19" text="// old screen still works until cutover" />
          </div>
        </div>
      </div>
    </section>
  );
}

function CodeLine({
  ln,
  text,
  kind,
}: {
  ln: string;
  text: string;
  kind?: "add" | "del";
}) {
  return (
    <div className={`code-line${kind ? ` ${kind}` : ""}`}>
      <span className="ln">{ln}</span>
      <span className="src">{text}</span>
    </div>
  );
}
